
  const iconTextSlider = document.querySelectorAll(".icon-text-slider.swiper");
  iconTextSlider.forEach((slider) => {
    let swiperInstance = new Swiper(slider, {
        spaceBetween: 0,
        centeredSlides: true,
        speed: 4000,
        autoplay: {
            delay: 1,
        },
        loop: true,
        slidesPerView:'auto',
        allowTouchMove: false,
        disableOnInteraction: true
    });
  });